// extracted by mini-css-extract-plugin
export default {"BackButton":"im0H6mYY","BackButtonMobileIcon":"k6uoQMAd","BackButtonDesktopIcon":"yx3rHhvG"};